import { StyledIcon, StyledIconBase, StyledIconProps } from "@styled-icons/styled-icon";
import { omit } from "lodash";
import { useState, useEffect, forwardRef, useRef } from "react";

type ReactSVGComponent = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & { title?: string }
>;

type Attrs = { [key: string]: string | null | undefined };

// TODO: fix this. on my (sia) local StyledIconBase appears to be typed as 'any'
// but when it's exported using turbo prune it has a different type & breaks when
// used in createCustomIcon.
const LooseStyledIconBase = StyledIconBase as any;

// Generic handling
export function createCustomIcon(
  Svg: ReactSVGComponent,
  displayName: string,
  padding?: string,
): StyledIcon {
  type t = typeof StyledIconBase;
  const icon = forwardRef<SVGSVGElement, StyledIconProps>(({ className, style, ...props }, ref) => {
    const svgRef = useRef<SVGSVGElement>(null);
    const test = <Svg ref={svgRef} />;
    const [allAttrs, setAllAttrs] = useState<Attrs>({});
    useEffect(() => {
      if (svgRef.current) {
        setAllAttrs(
          svgRef.current?.getAttributeNames().reduce<Attrs>((curr, name) => {
            curr[name] = svgRef.current?.getAttribute(name);
            return curr;
          }, {}),
        );
      }
    }, [svgRef]);
    const attrs = omit(allAttrs, "viewBox");

    return (
      <LooseStyledIconBase
        ref={ref}
        iconVerticalAlign="middle"
        iconAttrs={attrs}
        iconViewBox={(allAttrs && allAttrs["viewBox"]) || `0 0 24 24`}
        {...props}
        {...allAttrs}
        {...(className ? { className } : {})}
        style={{ ...style, padding: `${padding || "0px"}` }}
      >
        {test}
      </LooseStyledIconBase>
    );
  });

  icon.displayName = displayName;
  return icon;
}
